import { languageIntlLocale } from './locale'

const PRODUCT_NAMES = {
  sj: '黄金三角',
  bb: 'BB 交易',
  ub: 'UB 交易',
  grid: '现货网格交易',
  martin: '现货马丁交易',
  hedge: '合约 AI 交易',
  Term: '期现 AI 交易',
  term: '期现 AI 交易',
  futures_x: 'UPlus-X',
  astra: 'UPlus-Astra AI'
}

const PRODUCT_COLORS = {
  sj: '#e3b936',
  bb: '#805ad5',
  ub: '#f59e0b',
  grid: '#1f6bff',
  martin: '#12b76a',
  hedge: '#805ad5',
  Term: '#1f6bff',
  term: '#1f6bff',
  futures_x: '#1550cc',
  astra: '#b7791f'
}

const EXCHANGE_NAMES = {
  0: 'Binance',
  1: 'OKX',
  2: 'Gate',
  3: 'Bybit',
  bn: 'Binance',
  ok: 'OKX',
  gate: 'Gate',
  bybit: 'Bybit'
}

export function finiteNumber(value) {
  if (value === '' || value === null || value === undefined) return null
  const result = Number(value)
  return Number.isFinite(result) ? result : null
}

export function firstNumber(object, keys) {
  for (const key of keys) {
    const value = finiteNumber(object && object[key])
    if (value !== null) return value
  }
  return null
}

export function firstText(object, keys) {
  for (const key of keys) {
    const value = object && object[key]
    if (value !== '' && value !== null && value !== undefined) return String(value)
  }
  return ''
}

export function formatNumber(value, digits = 2) {
  const number = finiteNumber(value)
  if (number === null) return '--'
  return number.toLocaleString(languageIntlLocale(), {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  })
}

export function formatSigned(value, digits = 2, suffix = '') {
  const number = finiteNumber(value)
  if (number === null) return '--'
  const sign = number > 0 ? '+' : ''
  return `${sign}${formatNumber(number, digits)}${suffix}`
}

export function formatRate(value, options = {}) {
  const number = finiteNumber(value)
  if (number === null) return '--'
  const normalized = options.fraction ? number * 100 : number
  return formatSigned(normalized, options.digits === undefined ? 2 : options.digits, '%')
}

export function maskAccount(value) {
  if (!value) return '--'
  const text = String(value)
  if (text.includes('@')) {
    const parts = text.split('@')
    return `${parts[0].slice(0, 3)}***@${parts[1]}`
  }
  if (text.length <= 7) return text
  return `${text.slice(0, 3)}***${text.slice(-3)}`
}

export function mapLeader(item, index, currentUser) {
  const name = firstText(item, ['name', 'username', 'mobile', 'address', 'user_name'])
  const profit = firstNumber(item, ['trade_profit', 'profit'])
  const productType = firstText(item, ['product_type', 'strategy_type'])
  const symbol = firstText(item, ['coin', 'symbol'])
  const currentUserName = currentUser && typeof currentUser === 'object'
    ? firstText(currentUser, ['username', 'name', 'mobile', 'user_name'])
    : currentUser
  const currentUserId = currentUser && typeof currentUser === 'object'
    ? firstText(currentUser, ['user_id', 'userId', 'id'])
    : ''
  const leaderUserId = firstText(item, ['user_id', 'userId', 'uid'])
  const mineFlag = ['is_me', 'isMe', 'self', 'is_self', 'mine'].some(key => {
    const value = item && item[key]
    return value === true || value === 1 || value === '1' || String(value).toLowerCase() === 'true'
  })
  return {
    rank: firstNumber(item, ['rankNum', 'rank']) || index + 1,
    name: maskAccount(name),
    strategy: [PRODUCT_NAMES[productType] || productType, symbol].filter(Boolean).join(' · ') || '--',
    amountValue: profit,
    amount: formatSigned(profit),
    rate: formatRate(firstNumber(item, ['yield', 'profit_yield']), { fraction: true }),
    mine: mineFlag ||
      Boolean(currentUserName && name && String(currentUserName) === name) ||
      Boolean(currentUserId && leaderUserId && String(currentUserId) === leaderUserId),
    raw: item
  }
}

function strategyStatus(productType, state) {
  if (state === null || state === undefined || state === '') return 'unknown'
  const numericState = Number(state)
  if (['grid', 'martin'].includes(productType)) {
    if (numericState === 0) return 'running'
    if (numericState === 1) return 'paused'
  }
  if (['sj', 'ub', 'bb', 'hedge', 'term', 'futures_x', 'astra'].includes(productType)) {
    if (numericState === 1) return 'running'
    if (numericState === 2) return 'paused'
  }
  return 'unknown'
}

function normalizedSymbol(value) {
  return String(value || '')
    .replace(/[-_/]SWAP$/i, '')
    .replace(/[_-]/g, '/')
    .toUpperCase()
}

function strategyOldCoins(item) {
  const oldSymbol = firstText(item, ['coin_old'])
  if (!oldSymbol) return []
  const parts = String(oldSymbol).toUpperCase().split(/[-_/]/).filter(Boolean)
  return parts.length >= 2 ? [parts[1], parts[0]] : []
}
function strategyCoins(item, productType) {
  if (productType === 'astra') {
    return [firstText(item, ['coin_one', 'coin_new', 'coin']) || 'USDT']
  }
  if (['hedge', 'futures_x', 'term'].includes(productType)) {
    const oldCoins = strategyOldCoins(item)
    if (oldCoins.length) return oldCoins
    const quoteCoin = firstText(item, ['coin', 'coin_one', 'quote_coin'])
    const baseCoin = firstText(item, ['coin_two', 'base_coin'])
    const coins = [quoteCoin, baseCoin].filter(Boolean)
    if (coins.length) return coins
  }
  const spotCoins = [
    firstText(item, ['coin_one', 'quote_coin']),
    firstText(item, ['coin_two', 'base_coin']),
    firstText(item, ['coin_three'])
  ].filter(Boolean)
  if (spotCoins.length) return spotCoins
  const direct = firstText(item, ['symbol', 'coin', 'product_name'])
  return direct ? normalizedSymbol(direct).split('/').filter(Boolean) : []
}
function strategySymbol(item, productType) {
  if (productType === 'hedge' && Number(item.future_type) === 2) {
    const shortSymbol = firstText(item, ['symbol_short'])
    if (shortSymbol) return normalizedSymbol(shortSymbol)
    const sourceSymbol = firstText(item, ['symbol'])
    if (sourceSymbol) {
      const firstPart = String(sourceSymbol).split('_')[0]
      return normalizedSymbol(firstPart)
    }
  }
  const coins = strategyCoins(item, productType)
  return coins.length ? coins.map(normalizedSymbol).join('/') : '--'
}
function strategyPositionDirection(item, productType) {
  let firstPosition = null
  let secondPosition = null
  if (productType === 'bb') {
    firstPosition = firstNumber(item, ['space', 'space_one'])
    secondPosition = firstNumber(item, ['space_two'])
  } else if (productType === 'grid') {
    firstPosition = firstNumber(item, ['after_space'])
    secondPosition = firstNumber(item, ['front_space'])
  } else {
    return 'right'
  }
  const hasFirstPosition = firstPosition !== null && firstPosition > 0
  const hasSecondPosition = secondPosition !== null && secondPosition > 0
  if (hasFirstPosition && hasSecondPosition) return 'both'
  if (hasSecondPosition) return 'left'
  return 'right'
}

function isStableCoin(value) {
  return ['USDT', 'USDC', 'USD', 'BUSD', 'DAI'].includes(String(value || '').toUpperCase())
}

function strategyInvestment(item, productType) {
  if (productType === 'term') {
    return firstNumber(item, ['totalSpace', 'total_space', 'space'])
  }
  if (productType === 'martin') {
    return firstNumber(item, ['fund', 'space', 'first_space', 'full_space'])
  }
  if (productType === 'grid') {
    const quoteCoin = firstText(item, ['coin_one'])
    const baseCoin = firstText(item, ['coin_two'])
    if (isStableCoin(quoteCoin)) return firstNumber(item, ['after_space', 'all_space', 'space'])
    if (isStableCoin(baseCoin)) return firstNumber(item, ['front_space', 'all_space', 'space'])
    return firstNumber(item, ['all_space', 'after_space', 'front_space', 'space'])
  }
  if (productType === 'bb') {
    const coinOne = firstText(item, ['coin_one'])
    const coinTwo = firstText(item, ['coin_two'])
    if (isStableCoin(coinOne)) return firstNumber(item, ['space', 'space_one'])
    if (isStableCoin(coinTwo)) return firstNumber(item, ['space_two'])
    return firstNumber(item, ['capital', 'space', 'space_two'])
  }
  return firstNumber(item, [
    'space',
    'totalSpace',
    'total_space',
    'capital',
    'amount',
    'after_space',
    'fund',
    'full_space'
  ])
}

function strategyInvestmentUnit(item, productType) {
  if (productType === 'bb') {
    const coinOne = firstText(item, ['coin_one'])
    const coinTwo = firstText(item, ['coin_two'])
    if (isStableCoin(coinOne)) return coinOne.toUpperCase()
    if (isStableCoin(coinTwo)) return coinTwo.toUpperCase()
  }
  if (productType === 'grid' || productType === 'martin') {
    return firstText(item, ['coin_one']) || 'USDT'
  }
  return firstText(item, ['coin', 'coin_one']) || 'USDT'
}

function strategyProfitUnit(item, productType) {
  if (productType === 'bb') {
    const coinOne = firstText(item, ['coin_one'])
    const coinTwo = firstText(item, ['coin_two'])
    if (isStableCoin(coinTwo)) return coinTwo.toUpperCase()
    if (isStableCoin(coinOne)) return coinOne.toUpperCase()
  }
  if (productType === 'grid' || productType === 'martin') {
    return firstText(item, ['coin_one']) || 'USDT'
  }
  return firstText(item, ['coin', 'coin_one']) || 'USDT'
}

function strategyName(item, productType) {
  if (productType === 'hedge') {
    if (String(item.version) === 'oneWay') return '合约 AI 交易（单向版）'
    if (String(item.version_number).toLowerCase() === 'speed') return '合约 AI 交易（闪电版）'
  }
  if (productType === 'term') {
    if (Number(item.old_new) === 3) return '期现 AI 交易（闪电版）'
    if ([4, 5].includes(Number(item.old_new))) return '期现 AI 交易（BTC 版）'
  }
  if (productType === 'futures_x' && String(item.futures_version) === 'x_vip_astra') {
    return 'UPlus-多币种综合'
  }
  if (productType === 'futures_x' && Number(item.versionType || item.version_type) === 2) {
    return 'UPlus-X Pro'
  }
  return PRODUCT_NAMES[productType] ||
    firstText(item, ['strategy_name', 'robot_name', 'name']) ||
    '--'
}

export function mapRobot(item, index, total = 0) {
  const productType = firstText(item, ['product_type', 'strategy_type', 'type']).toLowerCase()
  const investment = strategyInvestment(item, productType)
  const profit = productType === 'martin'
    ? firstNumber(item, ['profit_loss', 'profit_total', 'profit_all'])
    : firstNumber(item, ['profit_total', 'profit_total_all', 'trade_profit', 'profit', 'income'])
  let profitRate = firstNumber(item, ['profit_rate', 'yield', 'profit_yield'])
  if (profitRate === null && investment && profit !== null) profitRate = profit / investment * 100
  const health = firstNumber(item, ['health', 'health_rate', 'margin_health'])
  const addTime = firstText(item, ['add_time', 'create_time'])
  const createdAt = addTime ? new Date(addTime.replace(/-/g, '/')).getTime() : NaN
  const days = Number.isFinite(createdAt)
    ? Math.max(0, Math.floor((Date.now() - createdAt) / 86400000))
    : null
  const robotType = item.__robotType !== undefined
    ? item.__robotType
    : firstText(item, ['robot_type'])
  const state = item.state !== undefined ? item.state : item.status
  const normalizedRaw = { ...item }
  if (productType === 'term') {
    if (item.uid_b) normalizedRaw.b_uid = item.uid_b
    if (item.uid_b2) normalizedRaw.b2_uid = item.uid_b2
    if (item.uid_c) normalizedRaw.c_uid = item.uid_c
  }
  if (addTime) {
    const parts = String(addTime).replace(' ', ':').replace(/:/g, '-').split('-')
    if (parts.length >= 5) normalizedRaw.add_time_short = `${parts[1]}-${parts[2]} ${parts[3]}:${parts[4]}`
  }
  const sourceRank = firstNumber(item, ['rank'])
  const rank = sourceRank === null
    ? Math.max(1, Number(total) - Number(index) || Number(index) + 1)
    : sourceRank

  return {
    id: firstText(item, ['strategy_uid', 'sid', 'uid', 'id']) || `${robotType}-${productType}-${index}`,
    name: strategyName(item, productType),
    productType,
    symbol: strategySymbol(item, productType),
    positionDirection: strategyPositionDirection(item, productType),
    exchange: EXCHANGE_NAMES[robotType] || EXCHANGE_NAMES[firstText(item, ['robot_type'])] || '--',
    investmentValue: investment,
    investment: formatNumber(investment),
    investmentUnit: strategyInvestmentUnit(item, productType).toUpperCase(),
    profitValue: profit,
    profit: formatSigned(profit),
    profitUnit: strategyProfitUnit(item, productType).toUpperCase(),
    rateValue: profitRate,
    rate: formatRate(profitRate),
    health,
    status: strategyStatus(productType, state),
    automation: ['grid', 'martin'].includes(productType) ? '半自动' : '全自动',
    rank,
    rankText: String(Math.trunc(rank)).padStart(2, '0'),
    color: PRODUCT_COLORS[productType] || '#1f6bff',
    days,
    raw: normalizedRaw
  }
}

function recordList(value) {
  if (Array.isArray(value)) return value
  if (value && Array.isArray(value.list)) return value.list
  if (value && Array.isArray(value.records)) return value.records
  return []
}

function statusText(state, kind) {
  const numericState = finiteNumber(state)
  if (kind === 'recharge') {
    if (numericState === 1) return '待支付'
    if (numericState === 2) return '已完成'
    if (numericState === 3) return '已关闭'
  }
  if (kind === 'withdraw') {
    if (numericState === null || numericState === 1) return '处理中'
    if (numericState === 2) return '已完成'
    return '已撤销'
  }
  return state === null || state === undefined || state === '' ? '--' : String(state)
}

export function mapAssetRecords(payload) {
  const rows = []
  const append = (source, kind, defaults) => {
    recordList(source).forEach((item, index) => {
      const state = finiteNumber(item.state)
      const amount = kind === 'recharge'
        ? firstNumber(item, ['chongzhi_money'])
        : (kind === 'withdraw'
          ? firstNumber(item, ['cash_money'])
          : firstNumber(item, [
            'chongzhi_money',
            'cash_money',
            'money',
            'amount',
            'deposit_change',
            'card_amount'
          ]))
      const time = kind === 'recharge'
        ? (state === 1
          ? firstText(item, ['time_req', 'time_ok'])
          : firstText(item, ['time_ok', 'time_req']))
        : (kind === 'withdraw'
          ? firstText(item, ['time_req'])
          : (kind === 'deal'
            ? firstText(item, ['time_delete', 'create_time', 'time_req', 'time_ok', 'add_time', 'time'])
            : firstText(item, ['time_req', 'time_ok', 'create_time', 'time_delete', 'add_time', 'time'])))
      const accountField = kind === 'recharge'
        ? finiteNumber(item.recharge_account)
        : (kind === 'withdraw' ? finiteNumber(item.withdrawal_account) : null)
      const account = ['recharge', 'withdraw'].includes(kind) && accountField !== null
        ? (accountField === 1 ? '资金账户' : '交易账户')
        : defaults.account
      rows.push({
        id: firstText(item, [
          'chongzhi_id',
          'cash_id',
          'uid',
          'order_no',
          'orderNo',
          'serial_number',
          'id'
        ]) || `${kind}-${index}`,
        time: time || '--',
        type: ['recharge', 'withdraw'].includes(kind) && Number(item.new_type) === 2
          ? '内部转账'
          : defaults.type,
        account,
        coin: firstText(item, ['coin', 'currency', 'token']) ||
          (kind === 'recharge' || kind === 'withdraw' ? 'USDT' : ''),
        amountValue: amount,
        amount: formatSigned(amount, 2, ' USDT'),
        balance: formatNumber(firstNumber(item, ['to_balance', 'deposit_balance', 'fuel_card_balance', 'balance'])),
        status: statusText(item.state, kind),
        category: defaults.category,
        icon: defaults.icon,
        tone: defaults.tone,
        raw: item
      })
    })
  }

  append(payload.recharges, 'recharge', {
    type: '链上充值',
    account: '资金账户',
    category: 'deposit',
    icon: 'el-icon-download',
    tone: 'blue'
  })
  append(payload.withdrawals, 'withdraw', {
    type: '链上提现',
    account: '资金账户',
    category: 'withdraw',
    icon: 'el-icon-upload2',
    tone: 'orange'
  })
  append(payload.changes, 'change', {
    type: '资产变动',
    account: '资金账户',
    category: 'asset',
    icon: 'el-icon-sort',
    tone: 'blue'
  })
  append(payload.deposits, 'deal', {
    type: '机器人结算',
    account: '燃料账户',
    category: 'profit',
    icon: 'el-icon-data-line',
    tone: 'green'
  })
  append(payload.pointCards, 'point-card', {
    type: '点卡记录',
    account: 'UPlus 点卡',
    category: 'fee',
    icon: 'el-icon-bank-card',
    tone: 'orange'
  })

  return rows.sort((a, b) => String(b.time).localeCompare(String(a.time)))
}

export function cumulativePoints(rows) {
  let total = 0
  return (Array.isArray(rows) ? rows : []).map(item => {
    const daily = firstNumber(item, ['profit', 'trade_profit'])
    if (daily !== null) total += daily
    return Number(total.toFixed(8))
  })
}
